import Joi from "joi";

const schema = Joi.object({
  id: Joi.number(),
  trx_desc: Joi.string().required().messages({ "string.empty": "Harap mengisi Deskripsi" }),
  sap_bktxt: Joi.string().required().messages({ "string.empty": "Harap mengisi Detail SAP" }),
  gnlldr: Joi.string().required().messages({ "string.empty": "Harap mengisi Akun GL" }),
  sap_shkzg: Joi.string().required().messages({ "string.empty": "Harap mengisi Tipe transaksi" }),
  range_code: Joi.string().required().messages({ "string.empty": "Harap mengisi Kode range" }),
  kunnr: Joi.number().required().messages({ "number.empty": "Harap mengisi kunnr" }),
  prctr: Joi.number().required().messages({ "number.empty": "Harap mengisi prctr" }),
  lifnr: Joi.number().required().messages({ "number.empty": "Harap mengisi lifnr" }),
  idtrx1: Joi.number().required().messages({ "number.empty": "Harap mengisi idtrx1" }),
  idtrx2: Joi.number().required().messages({ "number.empty": "Harap mengisi idtrx2" }),
  idtrx3: Joi.number().required().messages({ "number.empty": "Harap mengisi idtrx3" }),
});

export default schema;
